import "../../style/form/pharmacyform.scss";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { pharmacypopup } from "../../redux/reducer/counterslice";
import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import { presignedurl } from "../../../text/apidata";
import axios from "axios";
import { pharmacynew ,medicinetype } from "../../../text/apidata";
import Swal from "sweetalert2";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import {datetimestring} from "../../methods/Methods"
let u1 = [];

export default function PharmacyFormNew(props) {
  const pharmacystate = useSelector((state) => state.counter.pharmacypopup);
  const pharmacyid = useSelector((state) => state.counter.pharmacyid);

  const settings = useNavigate();
  const dispatch = useDispatch();
  const [pname, setpname] = useState("");
  const [checked, setChecked] = useState();
  const [checkedf, setCheckedf] = useState();
  const [checkedf2, setCheckedf2] = useState();


  const [file, setFile] = useState([]);
  const [imgfile, setimgfile] = useState([]);
  const [imgtype, setimgtype] = useState([]);

  const [mapurl, setmapurl] = useState([]);

  const [preurl, setpreurl] = useState([]);

  //
  const [pnameer, setpnameer] = useState(false);
  const [type, settype] = React.useState("");
  const [typeerror, settypeerror] = useState(false);
  const [productdis, setproductdis] = useState(false);
  const [productins, setproductins] = useState(false);
  const [producttime, setproducttime] = useState(false);

  const [alert, setalert] = useState(false);
  const [locationid, setlocationid] = useState(false);


  const [creatpharmacy, setcreatpharmacy] = useState({
    product_name: "",
    is_active: false,
    logo_url: [],
    medicine_type: "",
    product_description: "",
    featured_image: "",
    featured_product:false,
    need_prescription:false,
    pharmacy_location_code:"",
    time_required:"",
    instructions:"",
  })

  const [url, setUrl] = useState();
  const [imgfilenew, setimgfilenew] = useState([]);
  const [imgtypenew, setimgtypenew] = useState([]);
  const [preurlnew, setpreurlnew] = useState([]);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();

  const [medicinetypelist,setmedicinetypelist]=useState([])

  const formatTextWithLineBreaks = (text) => {
    return text.replace(/\n/g, "<br>");
  };
  useEffect(() => {
    console.log(pharmacystate)
    if (pharmacystate == "pharmacyedit") {
      props.loaderchange("true");

      axios({
        method: "get",
        url: pharmacynew + pharmacyid + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          props.loaderchange("false");
          console.log(res)
          setpname(res.data.data.product_name);
          setChecked(res.data.data.is_active);
          setCheckedf(res.data.data.featured_product)
          setCheckedf2(res.data.data.need_prescription)

          setFile(res.data.data.logo_url != null ? res.data.data.logo_url : "");
          if(res.data.data.medicine_type!=null){
          settype(res.data.data.medicine_type.id);
          }
          setUrl(res.data.data.featured_image);

          res.data.data.logo_url &&
            res.data.data.logo_url.length > 0 &&
            res.data.data.logo_url.map((ele) => {
              u1.push(ele);
            });

          setcreatpharmacy({
            ...creatpharmacy,
            product_name: res.data.data.product_name,
            is_active: res.data.data.is_active,
            logo_url: res.data.data.logo_url,
            medicine_type: res.data.data.medicine_type!=null?res.data.data.medicine_type.id:"",
            product_description: res.data.data.product_description,
            featured_image: res.data.data.featured_image,
            pharmacy_location_code:res.data.data.pharmacy_location_code,
            need_prescription:res.data.data.need_prescription,
            time_required:res.data.data.time_required,
            instructions:res.data.data.instructions,
            featured_product:res.data.data.featured_product
          });
        })
        .catch((error) => {
          console.log(error);
          props.popupalert("true");
          // props.popuptext(error.response.data.status.message);
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
          props.loaderchange("false");
        });
    }
    
    axios({
      method: "get",
      url: medicinetype,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        props.loaderchange("false");
        let objectArray=[]
        res.data.data.map((ele)=>{
          objectArray.push({ id: ele.id, value: ele.medicine_type });
        })
        setmedicinetypelist(objectArray)

      })
      .catch((error) => {
        console.log(error);
        props.popupalert("true");
        props.popuptext(error.response.data.status.message);
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
        props.loaderchange("false");
      });
  }, []);
  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
          dispatch(pharmacypopup(""));
          u1 = [];
          settings("/PharmacyNew");
          setalert(false);
        }
      });
    } else {
      dispatch(pharmacypopup(""));
      setalert(false);

      u1 = [];
      settings("/PharmacyNew");
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const validation = (e) => {
    setalert(true);
    if(e.target.name=="pharmacy_location_code"){
      const { name, value } = e.target;
      setlocationid(false);
      setcreatpharmacy({
        ...creatpharmacy,
        [name]: value,
      });
      if (e.target.value == "") {
        setlocationid(true);
      }

    }
    if (e.target.name == "product_name") {
      const { name, value } = e.target;
      setpname(e.target.value);
      setpnameer(false);
      setcreatpharmacy({
        ...creatpharmacy,
        [name]: value.trim().split(/ +/).join(" "),
      });
      if (e.target.value == "") {
        setpnameer(true);
      }
    }



    if (e.target.name == "check") {
      setChecked(e.target.checked);
      setcreatpharmacy({
        ...creatpharmacy,
        is_active: e.target.checked,
      });
    }
    
    if (e.target.name == "featured_product") {
      setCheckedf(e.target.checked);
      setcreatpharmacy({
        ...creatpharmacy,
        featured_product: e.target.checked,
      });
    }
    if (e.target.name == "need_prescription") {
      setCheckedf2(e.target.checked);
      setcreatpharmacy({
        ...creatpharmacy,
        need_prescription: e.target.checked,
      });
    }
    
    if (e.target.name == "product_description") {
      const { name, value } = e.target;
      // let text= value.replace(/\n/g, '<br>');
      setproductdis(false);
      setcreatpharmacy({
        ...creatpharmacy,
        [name]: value,
      });
    }
    if (e.target.name == "time_required") {
      const { name, value } = e.target;
      // let text= value.replace(/\n/g, '<br>');
      setproducttime(false);
      setcreatpharmacy({
        ...creatpharmacy,
        [name]: value,
      });
    }    if (e.target.name == "instructions") {
      const { name, value } = e.target;
      // let text= value.replace(/\n/g, '<br>');
      setproductins(false);
      setcreatpharmacy({
        ...creatpharmacy,
        [name]: value,
      });
    }
  };

  const newusercreate = () => {
    if (
      creatpharmacy.product_name != "" 
      // creatpharmacy.medicine_type != "" &&
      // creatpharmacy.product_description != "" &&
      // creatpharmacy.logo_url != "" &&
      // creatpharmacy.logo_url != null
    ) {
      if (pharmacystate != "pharmacyedit") {
          props.loaderchange("true");
          mapurl.forEach((ele) => {
            async function uploadimage() {
              const resp = await fetch(ele.url, {
                method: "PUT",
                body: ele.file,
                headers: {
                  // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                  "Content-Type": ele.type,
                  "X-Amz-ACL": "public-read",
                },
              })
                .then((res) => {
                  // console.log(res);
                  props.loaderchange("false");
                })

                .catch((err) => {
                  console.log(err);
                  props.loaderchange("false");
                  return null;
                });
            }
            uploadimage();
          });
          async function uploadimage1() {
            if (preurlnew && preurlnew.length > 0) {
              const resp1 = await fetch(preurlnew, {
                method: "PUT",
                body: imgfilenew,
                headers: {
                  // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                  "Content-Type": imgtypenew,
                  "X-Amz-ACL": "public-read",
                },
              }).catch((err) => {
                console.log(err);
                return null;
              });
            }
          }
          uploadimage1();
          setTimeout(() => {
            props.loaderchange("true");
            axios({
              method: "post",
              url: pharmacynew,
              data: creatpharmacy,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
              },
            })
              .then((res) => {
                // console.log(res);
                dispatch(pharmacypopup(""));
                settings("/PharmacyNew");
                props.loaderchange("false");
                // window.location.href = "/PharmacyNew";
                props.popupalert("true");
                props.popuptext("Pharmacy Product Created Successfully");

                setTimeout(() => {
                  props.popupalert("false");
                }, 2000);

                setFile([]);
                setimgfile([]);
                setimgtype([]);
                setmapurl([]);
                setpreurl([]);
                u1 = [];
                setalert(false);

                setcreatpharmacy({
                  ...creatpharmacy,
                  product_name: "",
                  is_active: true,
                  logo_url: [],
                  medicine_type: "",
                });
              })
              .catch((error) => {
                console.log(error);
                props.loaderchange("false");
              });
          }, 500);
        
      } else {
        // if (creatpharmacy.logo_url && creatpharmacy.logo_url.length > 0) {
          if (true) {

          props.loaderchange("true");

          mapurl.forEach((ele) => {
            async function editimage() {
              const resp = await fetch(ele.url, {
                method: "PUT",
                body: ele.file,
                headers: {
                  "Content-Type": ele.type,
                  "X-Amz-ACL": "public-read",
                },
              })
                .then((res) => {
                  // console.log(res);
                  props.loaderchange("false");
                })

                .catch((err) => {
                  console.log(err);
                  props.loaderchange("false");
                  return null;
                });
            }
            editimage();
          });

          async function editimage1() {
            if (preurlnew && preurlnew.length > 0) {
              console.log(preurlnew, imgtypenew, imgfilenew);
              const resp = await fetch(preurlnew, {
                method: "PUT",
                body: imgfilenew,
                headers: {
                  // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                  "Content-Type": imgtypenew,
                  "X-Amz-ACL": "public-read",
                },
              }).catch((err) => {
                console.log(err);
                return null;
              });
            }
          }

          editimage1();
          // console.log(creatpharmacy);
          setTimeout(() => {
            // console.log(creatpharmacy);
            props.loaderchange("true");
            axios({
              method: "put",
              url: pharmacynew + pharmacyid + "/",
              data: creatpharmacy,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
              },
            })
              .then((res) => {
                // console.log(res);
                dispatch(pharmacypopup(""));
                settings("/PharmacyNew");
                props.loaderchange("false");
                // window.location.href = "/PharmacyNew";
                props.popupalert("true");
                props.popuptext("Pharmacy Product Updated Successfully");

                setTimeout(() => {
                  props.popupalert("false");
                }, 2000);

                setFile([]);
                setimgfile([]);
                setimgtype([]);
                setmapurl([]);
                setpreurl([]);
                u1 = [];
                setalert(false);

                setcreatpharmacy({
                  ...creatpharmacy,
                  product_name: "",
                  is_active: true,
                  logo_url: [],
                  medicine_type: "",
                  time_required:"",
                  instructions:"",
              
                });
              })
              .catch((error) => {
                console.log(error);
                props.loaderchange("false");
              });
          }, 500);
        } else {
          if (pname == "") {
            setpnameer(true);
          }
          // if (type == "") {
          //   settypeerror(true);
          // }
          
        }
      }
    } else {
      console.log("liuoiu");
      if (
        creatpharmacy.product_name == "" ||
        creatpharmacy.product_name == null
      ) {
        setpnameer(true);
      }
      if(creatpharmacy.pharmacy_location_code==""){
        setlocationid(true);
      }


      // if (
      //   creatpharmacy.medicine_type == "" ||
      //   creatpharmacy.medicine_type == null
      // ) {
      //   settypeerror(true);
      // }
      // if (
      //   creatpharmacy.product_description == "" ||
      //   creatpharmacy.product_description == null
      // ) {
      //   setproductdis(true);
      // }

      // if (
      //   creatpharmacy.instructions == "" ||
      //   creatpharmacy.instructions == null
      // ) {
      //   setproductins(true);
      // }
      // if (
      //   creatpharmacy.time_required == "" ||
      //   creatpharmacy.time_required == null
      // ) {
      //   setproducttime(true);
      // }


      if (preurl == "" || preurl == null) {
        props.popupalert("true");
        props.popuptext("Upload Image to Continue");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      }
    }
  };
  const uploadSingleFile = (e) => {
    if (e.target.files.length == 1) {
      setalert(true);

      selectedImage(e);
      setCroppImageViewCount(2);
      setCroppImageView(true);
    } else if (e.target.files[0]) {
      setalert(true);

      console.log(e.target.files);
      var url;
      if (e.target.files.length > 0) {
        const filesArray = Array.from(e.target.files); // Convert FileList to array
        filesArray.forEach((ele) => {
          setFile((oldArray) => [
            ...oldArray,
            String(URL.createObjectURL(ele)),
          ]);
          setimgfile((oldArray) => [...oldArray, ele]);
          setimgtype((oldArray) => [...oldArray, ele.type]);
          // Do something with the 'url' object, if needed.
        });
        var filename_new = datetimestring()
        var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
        url = {
          multiple_files: filesArray.map((file) => ({
            ["filename"]:
              "assestsfortesting" +
              "/" +
              String(val) +
              String(file.name).replace(/ +/g, ""),
            ["file_type"]: file.type,
          })),
        };

        setTimeout(() => {
          console.log(url);
        }, 1000);
        axios({
          method: "post",
          url: presignedurl,
          data: url,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            console.log(res);
            res.data.data.map((data, index) => {
              setpreurl((oldArray) => [...oldArray, data]);
              u1.push(data.split("?")[0]);
              setmapurl((oldArray) => [
                ...oldArray,
                {
                  url: data,
                  type: url.multiple_files[index]["file_type"],
                  file: filesArray[index],
                },
              ]);
            });
            console.log(mapurl);
            // console.log(creatpharmacy.logo_url)
            // u1.push(String(res.data.data).split("?")[0]);
            // console.log(u1,"llll")
            setcreatpharmacy({
              ...creatpharmacy,
              logo_url: u1,
            });
            // console.log(u1)
            // console.log(creatpharmacy.logo_url)
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  const deleteFile = (e) => {
    setalert(true);

    const s = file.filter((item, index) => index !== e);
    const t = imgfile.filter((item, index) => index !== e);
    const u = preurl.filter((item, index) => index !== e);
    const v = mapurl.filter((item, index) => index !== e);
    const w = u1.filter((item, index) => index !== e);
    const i = imgtype.filter((item, index) => index !== e);

    setimgtype(i);
    setimgfile(t);
    setpreurl(u);
    setFile(s);
    setmapurl(v);
    console.log(w);
    u1 = [];

    u1 = w;
    console.log(u1);
    setcreatpharmacy({
      ...creatpharmacy,
      logo_url: u1,
    });
  };

  const handleChangetype = (event) => {
    setalert(true);

    settype(event.target.value);
    settypeerror(false);
    const { name, value } = event.target;
    setcreatpharmacy({
      ...creatpharmacy,
      [name]: value,
    });
  };

  ///
  const handleFiles = (e) => {
    selectedImage(e);
    setCroppImageViewCount(1);
    setCroppImageView(true);
    setalert(true);
  };

  const cancel = (e) => {
    setalert(true);
    setUrl("");
    setcreatpharmacy({
      ...creatpharmacy,
      featured_image: "",
    });
  };

  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };
  function getCroppedImg(a, crop, fileName) {
    const canvas = document.createElement("canvas");
      const image = document.getElementById("localimg");
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      if(crop){
        canvas.width = crop.width;
      canvas.height = crop.height;
      }
      else{
        canvas.width = image.width;
      canvas.height = image.height;
      }
      const ctx = canvas.getContext("2d");
  if(crop){
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  
  }
  else{
    ctx.drawImage(
      image,
      scaleX,
      scaleY,
      image.width* scaleX,
      image.height* scaleY,
      0,
      0,
      image.width,
      image.height,
    );
  
  }
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error("Canvas is empty");
            return;
          }
          const croppedFile = new File([blob], "croppedimg.jpg", {
            type: "image/jpeg",
          });
          if (CroppImageViewCount == 1) {
            console.log(croppedFile);
            setimgfilenew(croppedFile);
            setimgtypenew(croppedFile.type);
            var file = croppedFile;
            var reader = new FileReader();
            reader.onloadend = function () {
              setUrl(reader.result);
            };
            reader.readAsDataURL(file);
            var filename_new = datetimestring()
            var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
            var url1 = {
              multiple_files: [
                {
                  ["filename"]:
                    "assestsfortesting" +
                    "/" +
                    String(val) +
                    String(croppedFile.name).replace(/ +/g, ""),
                  // ["file_type"]: e.target.files[0].type,
                  ["file_type"]: croppedFile.type,
                },
              ],
            };

            setTimeout(() => {
              axios({
                method: "post",
                url: presignedurl,
                data: url1,
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token") + "",
                },
              })
                .then((res) => {
                  setpreurlnew(String(res.data.data));

                  setcreatpharmacy({
                    ...creatpharmacy,
                    featured_image: String(res.data.data).split("?")[0],
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
            }, 500);
          } else if (CroppImageViewCount == 2) {
            const filesArray1 = croppedFile; // Convert FileList to array
            setFile((oldArray) => [
              ...oldArray,
              String(URL.createObjectURL(croppedFile)),
            ]);

            setimgfile((oldArray) => [...oldArray, croppedFile]);
            setimgtype((oldArray) => [...oldArray, croppedFile.type]);
            var file = croppedFile;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            var filename_new = datetimestring()
            var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
            var url = {
              multiple_files: [
                {
                  ["filename"]:
                    "assestsfortesting" +
                    "/" +
                    String(val) +
                    String(croppedFile.name).replace(/ +/g, ""),
                  // ["file_type"]: e.target.files[0].type,
                  ["file_type"]: croppedFile.type,
                },
              ],
            };
            setTimeout(() => {
              axios({
                method: "post",
                url: presignedurl,
                data: url,
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token") + "",
                },
              })
                .then((res) => {
                  console.log(res);
                  res.data.data.map((data, index) => {
                    setpreurl((oldArray) => [...oldArray, data]);
                    u1.push(data.split("?")[0]);
                    setmapurl((oldArray) => [
                      ...oldArray,
                      {
                        url: data,
                        type: url.multiple_files[index]["file_type"],
                        file: filesArray1,
                      },
                    ]);
                  });
                  console.log(mapurl);
                  // console.log(creatpharmacy.logo_url)
                  // u1.push(String(res.data.data).split("?")[0]);
                  // console.log(u1,"llll")
                  setcreatpharmacy({
                    ...creatpharmacy,
                    logo_url: u1,
                  });
                  // console.log(u1)
                  // console.log(creatpharmacy.logo_url)
                })
                .catch((error) => {
                  console.log(error);
                });
            }, 500);
          }
          blob.name = fileName;
          setCroppImageView(false);
          let fileUrl = window.URL.createObjectURL(blob);
          console.log(fileUrl);
          resolve(fileUrl);
        }, "image/jpeg");
      });
    
  }
  const setCompletedCrop = async (c) => {
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  return (
    <>
      <div className="maincontainer">
        <div className="parent-pharmacyform">
          <div className="create-pharmacyform card">
            <div class="modal-header">
              <h5 class="modal-title">
                {pharmacystate == "pharmacyedit"
                  ? "Pharmacy Edit"
                  : "Pharmacy Create"}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => cancelnewuser(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>

            <div class="modal-body" style={{ padding: "0 !important" }}>
              <form
                style={{ padding: "0 1.5rem 0rem" }}
                className="formspace"
                onSubmit={handleSubmit}
              >
                <div
                  class="form-row"
                  style={
                    {
                      // display: "flex",
                      // flexFlow: "row wrap",
                      // placeContent: "center space-between",
                      // alignItems: "center",
                    }
                  }
                >
                  <div class="form-group col-md-6 p-1 m-0">
                    <label for="validationCustom01" class="form-label">
                      Product Name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      name="product_name"
                      autoComplete="off"
                      value={
                        // pharmacystate == "pharmacyedit"
                        //   ? creatpharmacy.product_name
                        //   :
                        pname
                      }
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => validation(e)}
                    ></input>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {pnameer ? "Name Required" : ""}{" "}
                    </p>
                  </div>

                  <div class="form-group col-md-6 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Medicine Type
                    </label>
                    <select
                      class="form-select"
                      id="validationCustom04"
                      value={type}
                      name="medicine_type"
                      onChange={handleChangetype}
                    >
                      <option selected disabled value="">
                        Choose...
                      </option>
                      {medicinetypelist.map((ele)=>{
                        console.log(ele)
                        return(
                          <option value={ele.id}>{ele.value}</option>
                        )
                      })}
                    </select>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {typeerror ? "Medicine Type" : ""}
                    </p> */}
                  </div>

                </div>
                <div className="form-row">
                  <div className="form-group col-md-4 p-1 m-0">
                    <label class="form-label">Product Description</label>

                    <textarea
                      value={creatpharmacy.product_description}
                      name="product_description"
                      class="form-control"
                      id="validationCustomtextarea"
                      style={{ resize: "none" }}
                      rows="3"
                      onChange={(e) => {
                        validation(e);
                      }}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></textarea>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {productdis && "Product Discription Required"}
                    </p> */}
                  </div>
                  <div className="form-group col-md-4 p-1 m-0">
                    <label class="form-label">Instructions</label>

                    <textarea
                      value={creatpharmacy.instructions}
                      name="instructions"
                      class="form-control"
                      id="validationCustomtextarea"
                      style={{ resize: "none" }}
                      rows="3"
                      onChange={(e) => {
                        validation(e);
                      }}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></textarea>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {productins && "Instructions Required"}
                    </p> */}
                  </div>                 
                   <div className="form-group col-md-4 p-1 m-0">
                    <label class="form-label">Time Required</label>

                    <textarea
                      value={creatpharmacy.time_required}
                      name="time_required"
                      class="form-control"
                      id="validationCustomtextarea"
                      style={{ resize: "none" }}
                      rows="3"
                      onChange={(e) => {
                        validation(e);
                      }}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></textarea>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {producttime && "Time Required Required"}
                    </p> */}
                    

                  </div>
                  <div
                    className="form-group col-md-6 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <>
                      {url ? (
                        <img
                          src={url}
                          onClick={(e) => {
                            window.open(url);
                          }}
                          className="pointer"
                          style={{
                            height: 115,
                            width: 115,
                            marginRight: 25,
                            borderRadius: "50%",
                          }}
                          alt="Image"
                        />
                      ) : (
                        <p style={{ margin: 0, padding: 10 }}>
                          Upload Featured Picture
                        </p>
                      )}

                      {!url ? (
                        <Button
                          className="doctorupload"
                          variant="contained"
                          component="label"
                        >
                          <p>
                            Upload Image
                            <input
                              type="file"
                              hidden
                              accept="image/png, image/jpeg"
                              onChange={(e) => handleFiles(e)}
                            />
                          </p>
                        </Button>
                      ) : (
                        <></>
                      )}

                      {url ? (
                        <Button
                          className="remove"
                          variant="contained"
                          onClick={(e) => cancel(e)}
                        >
                          {" "}
                          <p>Remove Image</p>
                        </Button>
                      ) : (
                        ""
                      )}
                    </>
                  </div>
                </div>

                <div
                  class="form-row"
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    placeContent: "center space-between",
                    alignItems: "center",
                    marginTop: "18px",
                  }}
                >
                  <div class="col-md-6 p-1 m-0">
                    <div className="form-group preview">
                      <div className="imgouters" style={{ display: "flex" }}>
                        {file &&
                          file.length > 0 &&
                          file.map((item, index) => {
                            return (
                              <>
                                <img
                                  onClick={(e) => {
                                    window.open(item);
                                  }}
                                  className="pointer"
                                  style={{
                                    height: "2.5rem",
                                    width: "2.5rem",
                                    borderRadius: "50%",
                                    margin: "10px 10px 10px 20px",
                                  }}
                                  src={item}
                                  alt=""
                                />
                                <button
                                  type="button"
                                  style={{
                                    position: "relative",
                                    height: "20px",
                                    width: "20px",
                                    margin: "-10px",
                                    borderRadius: "50%",
                                    backgroundColor: "#1b5a90",
                                  }}
                                  onClick={() => deleteFile(index)}
                                >
                                  <i
                                    class="bi bi-x"
                                    style={{
                                      margin: "inherit",
                                      color: "white",
                                      position: "relative",
                                      bottom: "2px",
                                    }}
                                  ></i>
                                </button>
                              </>
                            );
                          })}
                      </div>
                    </div>

                    <div className="form-group"></div>
                    <Button
                      className="pharmacyupload"
                      variant="contained"
                      component="label"
                      disabled={file && file.length > 5}
                    >
                      {" "}
                      <input
                        type="file"
                        disabled={file && file.length > 5}
                        hidden
                        className="form-control"
                        accept="image/png, image/jpeg"
                        onChange={uploadSingleFile}
                        multiple
                      />
                      Upload Image
                    </Button>
                  </div>
                  <div class="col-md-6 p-1 m-0" style={{display:"flex",gap:"10px",justifyContent:"center"}}>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="check"
                        checked={checked}
                        onChange={(e) => validation(e)}
                        id="invalidCheck"
                      ></input>
                      <label class="form-check-label" for="invalidCheck">
                        Is Active
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="featured_product"
                        checked={checkedf}
                        onChange={(e) => validation(e)}
                        id="invalidCheck"
                      ></input>
                      <label class="form-check-label" for="invalidCheck">
                      Featured Product
                      </label>
                    </div>
                    

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="need_prescription"
                        checked={checkedf2}
                        onChange={(e) => validation(e)}
                        id="invalidCheck"
                      ></input>
                      <label class="form-check-label" for="invalidCheck">
                      Need Prescription
                      </label>
                    </div>
                  </div>

                </div>
                {/* <div dangerouslySetInnerHTML={{ __html: formatTextWithLineBreaks(creatpharmacy.product_description) }} /> */}

                <div
                  class="form-row"
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    placeContent: "center space-between",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group col-md-12 pb-3 pt-4 m-0">
                    <button
                      type="submit"
                      class="btn btn-primary  create"
                      onClick={(e) => newusercreate(e)}
                      disabled={
                        pharmacystate == "pharmacyedit" && !alert ? true : false
                      }
                    >
                      {pharmacystate == "pharmacyedit"
                        ? "Update Pharmacy "
                        : "Create Pharmacy"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {CroppImageView && (
        <div className="Cropper_Wrapper">
          <div className="Cropper_Inner_Wrapper">
            <ReactCrop
              src={imgsrc}
              crop={crop}
              ruleOfThirds
              onImageLoaded={onImageLoaded}
              onChange={(c) => {
                setCrop(c);
                console.log(c);
              }}
              // onComplete={(c) => setCompletedCrop(c)}
            >
              <img src={imgsrc} ref={imgRef} id="localimg" />
            </ReactCrop>
          </div>
          <div className="CropperFooter">
            <button onClick={(e) => setCroppImageView(false)}>Cancel</button>
            <button onClick={(e) => setCompletedCrop(crop)}>Save</button>
          </div>
        </div>
      )}
    </>
  );
}
